import PropTypes from 'prop-types';

import { NavigationList, Sticky } from 'components/common/navigation';

const LoginFooter = ({ footerLinks, returnToClassic }) => (
  <Sticky position="bottom" elevation={4}>
    {/* {returnToClassic} */}
    <NavigationList
      isLink
      value={false}
      variant="scrollable"
      scrollButtons="on"
      navItems={footerLinks}
      className="ttc justify-center home--footer"
    />
  </Sticky>
);

LoginFooter.propTypes = {
  footerLinks: PropTypes.array.isRequired,
  returnToClassic: PropTypes.node.isRequired,
};

export default LoginFooter;
